import { Pipe, PipeTransform } from '@angular/core';
/*
 * Strips HTML
 * Takes an input parameter HTML.
 * Usage:
 *   content | striphtml
 * Example:
 *   <p [innerHTML]="content | stripHtml"></p>
 */
@Pipe({
  name: 'stripHtml',
  standalone: false,
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: any): any {
    if (value === null || value === '') {
      return '';
    } else {
      return value.replace(/<(?:.|\n)*?>/gm, ' ');
    }
  }
}
